import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import AuthNavbar from '../components/AuthNavbar/AuthNavbar'
import StudentDataContainer from '../components/StudentDataContainer/StudentDataContainer'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

function Student() {

  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <Container>
        <div className="d-flex flex-column w-100">

          <AuthNavbar />
          <div className="mt-5 mx-3">
            <Container fluid>
              <Row>
                <Col md={4}>
                  {/* <HomeTitle title={currentLocal.home.Welcome+" , "+studentData?.name} /> */}

                </Col>

                <StudentDataContainer />

              </Row>


            </Container>





          </div>

        </div>
      </Container>
    </div>)
}

export default Student
